(function () {
  "use strict";

  var ROOT_SELECTOR = "[data-gs-sticky-atc]";
  var TRIPTYQUE_HANDLES = [
    "le-triptyque-complet",
    "triptyque-a-return-to-self",
    "say-only-what-is-essential-keep-words-rare-4",
    "say-only-what-is-essential-keep-words-rare-3",
    "sag-nur-das-wesentliche-bewahre-die-seltenen-worte-4",
  ];

  function emit(name, details) {
    var payload = Object.assign({ event: name }, details || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (typeof window.hj === "function") {
      try {
        window.hj("event", name);
      } catch (_) {}
    }
  }

  function localeCopy() {
    var lang = (
      (window.Shopify && window.Shopify.locale) ||
      document.documentElement.lang ||
      "fr"
    )
      .toLowerCase()
      .slice(0, 2);
    var copies = {
      fr: {
        normal: "Ajouter",
        trip: "Ajouter les 3 toiles",
        unavailable: "Indisponible",
        selection: "Votre sélection",
      },
      en: {
        normal: "Add",
        trip: "Add all 3 canvases",
        unavailable: "Unavailable",
        selection: "Your selection",
      },
      de: {
        normal: "Hinzufügen",
        trip: "Alle 3 Leinwände hinzufügen",
        unavailable: "Nicht verfügbar",
        selection: "Ihre Auswahl",
      },
      es: {
        normal: "Añadir",
        trip: "Añadir los 3 lienzos",
        unavailable: "No disponible",
        selection: "Tu selección",
      },
      nl: {
        normal: "Toevoegen",
        trip: "Alle 3 doeken toevoegen",
        unavailable: "Niet beschikbaar",
        selection: "Uw selectie",
      },
      it: {
        normal: "Aggiungi",
        trip: "Aggiungi tutte e 3 le tele",
        unavailable: "Non disponibile",
        selection: "La tua selezione",
      },
    };
    return copies[lang] || copies.fr;
  }

  function unique(values) {
    return values.filter(function (value, index) {
      return value && values.indexOf(value) === index;
    });
  }

  function init(root) {
    if (!root || root.dataset.gsStickyAtcBound === "true") return;

    var scope =
      root.closest("product-info") ||
      document.querySelector(
        'product-info, .product-section, [data-section-type="product"]',
      );
    if (!scope) return;

    var masterButtons = Array.prototype.slice.call(
      scope.querySelectorAll(
        '[data-add-to-cart], .product-form__cart-submit, button[name="add"]',
      ),
    );
    var masterButton = masterButtons.find(function (button) {
      return !root.contains(button) && button.closest("form");
    });
    if (!masterButton) return;

    var form = masterButton.closest("form");
    var stickyButton = root.querySelector("[data-gs-sticky-atc-button]");
    var labelNode = root.querySelector("[data-gs-sticky-atc-label]");
    var priceNode = root.querySelector("[data-gs-sticky-atc-price]");
    var summaryNode = root.querySelector("[data-gs-sticky-atc-summary]");
    var eyebrowNode = root.querySelector("[data-gs-sticky-atc-eyebrow]");
    if (!form || !stickyButton || !labelNode || !priceNode || !summaryNode)
      return;

    root.dataset.gsStickyAtcBound = "true";
    var handle =
      root.dataset.productHandle ||
      (scope.dataset && scope.dataset.productHandle) ||
      "";
    var isTriptyque = TRIPTYQUE_HANDLES.indexOf(handle) !== -1;
    var copy = localeCopy();
    var variantChanged = false;
    var nextAddSource = "main";
    var shownTracked = false;
    var lastOpenAt = 0;
    var lastVariantId = "";
    var lastSignature = "";

    if (eyebrowNode) eyebrowNode.textContent = copy.selection;

    function variantId() {
      var input = form.querySelector('[name="id"]');
      return input ? String(input.value || "") : "";
    }

    function variantControls() {
      var selectors = [
        "variant-selects select",
        'variant-selects input[type="radio"]',
        ".variant-input-wrap select",
        ".variant-wrapper select",
        '[data-gs-variant-sheet] input[type="radio"]',
        "[data-gs-variant-sheet-open]",
      ];
      return Array.prototype.slice.call(
        scope.querySelectorAll(selectors.join(",")),
      );
    }

    function selectedOptions() {
      var values = [];
      scope
        .querySelectorAll(
          "variant-selects select, .variant-input-wrap select, .variant-wrapper select",
        )
        .forEach(function (select) {
          if (select.name === "id") return;
          var option =
            select.options && select.selectedIndex >= 0
              ? select.options[select.selectedIndex]
              : null;
          var value = option
            ? option.textContent.trim()
            : String(select.value || "").trim();
          if (value) values.push(value);
        });
      scope
        .querySelectorAll(
          'variant-selects input[type="radio"]:checked, [data-gs-variant-sheet] input[type="radio"]:checked',
        )
        .forEach(function (input) {
          var value = String(input.value || "").trim();
          if (value) values.push(value);
        });
      return unique(values);
    }

    function currentPrice() {
      var candidates = Array.prototype.slice.call(
        scope.querySelectorAll(
          ".product-block--price [data-product-price], .product__content [data-product-price], [data-product-blocks] [data-product-price], .product__price [data-product-price], [data-product-price]",
        ),
      );
      var node = candidates.find(function (candidate) {
        return (
          !root.contains(candidate) &&
          candidate.textContent.trim() &&
          !candidate.closest("s, del")
        );
      });
      return node ? node.textContent.replace(/\s+/g, " ").trim() : "";
    }

    function detailBase(extra) {
      return Object.assign(
        {
          product_handle: handle,
          variant_id: variantId(),
          is_triptyque: isTriptyque,
          selected_options: selectedOptions().join(" · "),
        },
        extra || {},
      );
    }

    function sync() {
      try {
        var options = selectedOptions();
        var price = currentPrice();
        var unavailable =
          masterButton.disabled ||
          masterButton.getAttribute("aria-disabled") === "true";
        var loading =
          masterButton.classList.contains("is-loading") ||
          masterButton.getAttribute("aria-busy") === "true";
        var label = unavailable
          ? copy.unavailable
          : isTriptyque
            ? copy.trip
            : copy.normal;

        summaryNode.textContent =
          options.join(" · ") || (isTriptyque ? copy.trip : copy.selection);
        summaryNode.setAttribute("title", summaryNode.textContent);
        labelNode.textContent = label;
        priceNode.textContent = price ? " — " + price : "";
        stickyButton.disabled = unavailable || loading;
        stickyButton.setAttribute(
          "aria-disabled",
          stickyButton.disabled ? "true" : "false",
        );
        stickyButton.classList.toggle("is-loading", loading);
        stickyButton.setAttribute(
          "aria-label",
          (label + (price ? " — " + price : "")).trim(),
        );
        root.style.setProperty(
          "--gs-sticky-atc-height",
          root.offsetHeight + "px",
        );
        document.documentElement.style.setProperty(
          "--gs-sticky-atc-height",
          root.offsetHeight + "px",
        );
      } catch (error) {
        emit(
          "variant_change_error",
          detailBase({ reason: "sticky_sync_exception" }),
        );
      }
    }

    function overlayOpen() {
      if (
        document.body.classList.contains("js-drawer-open") ||
        document.body.classList.contains("drawer-open") ||
        document.documentElement.classList.contains("js-drawer-open")
      )
        return true;
      return Boolean(
        document.querySelector(
          'dialog[open], .gs-bundle__modal:not([hidden]), .gs-variant-sheet__dialog[aria-hidden="false"]:not([hidden]), .drawer.is-open, .drawer--visible, [aria-modal="true"]:not([hidden])[aria-hidden="false"]',
        ),
      );
    }

    function setVisibility() {
      var mobile = window.matchMedia("(max-width: 768px)").matches;
      var rect = masterButton.getBoundingClientRect();
      // Show only before the native CTA enters the viewport, never after it.
      var viewportHeight = window.visualViewport
        ? window.visualViewport.height
        : window.innerHeight;
      var visible = mobile && rect.width > 0 && rect.height > 0 &&
        rect.top >= viewportHeight && !overlayOpen();
      root.classList.toggle("is-visible", visible);
      root.setAttribute("aria-hidden", visible ? "false" : "true");
      document.body.classList.toggle("gs-sticky-atc-active", visible);
      if (visible && !shownTracked) {
        shownTracked = true;
        emit("sticky_atc_view", detailBase());
      }
    }

    function validateVariant(beforeVariant, beforeSignature) {
      window.setTimeout(function () {
        sync();
        var afterVariant = variantId();
        var afterSignature = selectedOptions().join(" · ");
        var price = currentPrice();
        if (!afterVariant) {
          emit(
            "variant_change_error",
            detailBase({ reason: "missing_variant_id" }),
          );
          return;
        }
        if (!price) {
          emit("variant_change_error", detailBase({ reason: "missing_price" }));
          return;
        }
        if (
          afterSignature &&
          afterSignature !== beforeSignature &&
          afterVariant === beforeVariant
        ) {
          emit(
            "variant_change_error",
            detailBase({ reason: "variant_id_not_updated" }),
          );
          return;
        }
        lastVariantId = afterVariant;
        lastSignature = afterSignature;
        emit("variant_selected", detailBase());
      }, 500);
    }

    variantControls().forEach(function (control) {
      var openHandler = function () {
        var now = Date.now();
        if (now - lastOpenAt < 450) return;
        lastOpenAt = now;
        emit(
          "variant_open",
          detailBase({
            control:
              control.getAttribute("data-option-kind") ||
              control.name ||
              control.tagName.toLowerCase(),
          }),
        );
      };
      control.addEventListener("pointerdown", openHandler, { passive: true });
      control.addEventListener("focus", openHandler, { passive: true });
      if (!control.matches("[data-gs-variant-sheet-open]")) {
        control.addEventListener("change", function () {
          var beforeVariant = lastVariantId || variantId();
          var beforeSignature = lastSignature || selectedOptions().join(" · ");
          variantChanged = true;
          validateVariant(beforeVariant, beforeSignature);
        });
      }
    });

    masterButton.addEventListener(
      "click",
      function () {
        if (!variantChanged) return;
        emit("add_after_variant_change", detailBase({ source: nextAddSource }));
        variantChanged = false;
        nextAddSource = "main";
      },
      true,
    );

    stickyButton.addEventListener("click", function (event) {
      event.preventDefault();
      sync();
      if (stickyButton.disabled || masterButton.disabled) return;
      nextAddSource = "sticky";
      emit("sticky_atc_click", detailBase());
      masterButton.click();
    });

    document.addEventListener("theme:variant:change", function () {
      window.setTimeout(sync, 0);
    });
    document.addEventListener("theme:product:add-error", function () {
      window.setTimeout(sync, 0);
    });
    window.addEventListener("scroll", setVisibility, { passive: true });
    window.addEventListener(
      "resize",
      function () {
        sync();
        setVisibility();
      },
      { passive: true },
    );

    var priceTarget = Array.prototype.slice
      .call(scope.querySelectorAll("[data-product-price]"))
      .find(function (candidate) {
        return !root.contains(candidate);
      });
    if (priceTarget)
      new MutationObserver(sync).observe(priceTarget, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    new MutationObserver(function () {
      sync();
      setVisibility();
    }).observe(masterButton, {
      attributes: true,
      attributeFilter: ["disabled", "aria-disabled", "aria-busy", "class"],
    });
    new MutationObserver(setVisibility).observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    document
      .querySelectorAll(
        "dialog, .gs-bundle__modal, .gs-variant-sheet__dialog, .drawer",
      )
      .forEach(function (overlay) {
        new MutationObserver(setVisibility).observe(overlay, {
          attributes: true,
          attributeFilter: ["open", "hidden", "aria-hidden", "class"],
        });
      });

    window.addEventListener("load", setVisibility, { once: true });
    if (window.ResizeObserver) new ResizeObserver(setVisibility).observe(scope);
    if (window.visualViewport)
      window.visualViewport.addEventListener("resize", setVisibility, { passive: true });

    lastVariantId = variantId();
    lastSignature = selectedOptions().join(" · ");
    sync();
    setVisibility();
  }

  function start() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", start, { once: true });
  else start();
})();
